import React from 'react'
import styled, { css , keyframes} from 'styled-components';
import tulkojumi from 'utils/tulkojumi';

const slideIn = keyframes`
  from {
    transform: translateY(-20px);
  }

  to {
     transform: translateY(0px);
  }
`;
const fadeIn = keyframes`
  from {
    opacity:0;
  }

  to {
     opacity:1;
  }
`;


const Loader = styled.div`
    display: flex;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    position: fixed;
    background-color: rgba(240, 248, 255, 0.8);
    z-index: 999;
    padding: 0;
    margin: 0;
    align-items: center;
    text-align: center;
    justify-content: center;
    animation: ${fadeIn} 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    > * {
    	 animation: ${slideIn} 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }
`;




export default ({teksti}) =>
  (<Loader>
    <h2>
      {teksti?tulkojumi(teksti, 'loading'):'Loading'} 
    </h2>
  </Loader>)



// WEBPACK FOOTER //
// ./src/components/Loading.js